export interface PageHeaderProps {
  moduleName?: string;
  children?: React.ReactNode;
  title: string;
}

export const PageHeader = ({
  moduleName = '',
  children = undefined,
  title
}: PageHeaderProps) => {
  return (
    <div className="border-soFresh-140 flex max-h-20 min-h-20 w-full items-center justify-between border-b px-6 py-4">
      <div className="flex flex-col">
        <p className="text-soClean-180 text-sm">{moduleName}</p>
        <h2 className="text-soClean-100">{title}</h2>
      </div>
      <div>{children}</div>
    </div>
  );
};
